import React, { useMemo, useState } from 'react';

export type Option = { label: string; value: string | number };

type Props = {
  label?: string;
  options: Option[];
  value?: string | number;
  onChange?: (value: string | number | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
};

export const ComboBoxWithSearch: React.FC<Props> = ({ label, options, value, onChange, placeholder = 'Select…', disabled }) => {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => {
    const q = query.toLowerCase();
    return options.filter(o => o.label.toLowerCase().includes(q));
  }, [options, query]);

  return (
    <div className="w-full">
      {label && <div className="mb-1 text-sm text-foreground">{label}</div>}
      <div className="rounded-md border bg-card p-2">
        <input
          className="mb-2 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
          placeholder="Search..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          disabled={disabled}
        />
        <select
          className="w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
          value={value === undefined ? '' : String(value)}
          onChange={e => onChange?.(e.target.value)}
          disabled={disabled}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {filtered.map(opt => (
            <option key={opt.value} value={String(opt.value)}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ComboBoxWithSearch;
